import { HashtagOutputSchema } from "src/features/Hashtags/models";
import { z } from "zod";

const required_error = "This field is required";

// Text Carousel Banner
export const TextCarouselBannerInputSchema = z.object({
	template: z.literal("textBanner"),

	bannerType: z.enum(["internal", "sponsored"]).default("internal").nullable(),

	backgroundColor: z
		.string()
		.min(1, "This field is required")
		.nullable()
		.default("#000000"),

	foregroundColor: z
		.string()
		.min(1, "This field is required")
		.nullable()
		.default("#FFFFFF"),

	headingText: z.string().min(1, "This field is required").nullable(),

	subheadingText: z.string().nullish(),

	name: z.string().min(1, "This field is required").nullable(),

	linkType: z.enum(["WEB", "FEED"]).nullish(),

	webLink: z.string().nullish(),

	openInBrowser: z.boolean().default(false),

	feed: z.string().uuid().nullish(),

	audienceGroupIds: z.array(z.number()).default([])
});

export const TextCarouselBannerOutputSchema = z.object({
	id: z.number(),

	template: z.literal("textBanner"),

	bannerType: z.enum(["internal", "sponsored"]).nullable(),

	backgroundColor: z.string().nullable().default("#000000"),

	foregroundColor: z.string().nullable().default("#FFFFFF"),

	headingText: z.string().nullable(),

	subheadingText: z.string().nullish(),

	name: z.string().nullable(),

	linkType: z.enum(["WEB", "FEED"]).nullish(),

	webLink: z.string().nullish(),

	openInBrowser: z.boolean().default(false),

	feed: HashtagOutputSchema.nullable(),

	activeDays: z.number(),

	createdBy: z
		.object({
			id: z.number(),

			firstName: z.string(),

			lastName: z.string()
		})
		.nullable(),

	updatedAt: z.coerce.date(),

	createdAt: z.coerce.date(),

	audienceGroups: z
		.array(z.object({ id: z.number(), name: z.string() }))
		.default([])
});

export type TextCarouselBannerInput = z.infer<
	typeof TextCarouselBannerInputSchema
>;

export type TextCarouselBannerModel = z.infer<
	typeof TextCarouselBannerOutputSchema
>;
